/* ============================================================
   MX MOTORSPORTS – Anfrageformular, Verhalten
   Datei: assets/mxm-anfrage.js
   Gehoert zu sections/mxm-anfrage.liquid und assets/mxm-anfrage.css

   Hier gepflegt wird:
   - MODELLE : die BMW-Fahrzeugliste (Baureihe -> Modelle)
   - THEMEN  : die Klartext-Namen fuer ?thema= in der Adresszeile
   Die anderen Marken und ihre Modelle kommen aus snippets/mx-marken-liste
   (im Markenfeld als data-k und data-modelle). Vorbelegung: ?marke=audi&modell=RS6%20C8,
   sonst aus ?thema= (z. B. audi-rs6-c8-leistungssteigerung) oder aus der Fahrzeugwahl im Browser.
   ============================================================ */

(function(){
  var root = document.querySelector('.mxm-anfrage');
  if(!root) return;
  var form = root.querySelector('form');
  if(!form) return;

  /* ---- Anlass aus ?thema= in der Adresszeile ----
     Shopify-Liquid kann Query-Parameter nicht lesen, das macht der Browser.
     Neue Themen hier ergaenzen: 'slug-in-der-url': 'Text fuer Kunde und Mail' */
  var THEMEN = {
    /* --- Uebersicht --- */
    'leistungen':                'Allgemeine Anfrage',
    /* --- Kategorieseiten --- */
    'motor-getriebe':            'Motor und Getriebe',
    'fahrwerkstechnik':          'Fahrwerkstechnik',
    'leistungssteigerung':       'Leistungssteigerung',
    'service-wartung':           'Service und Wartung',
    'carbon-aerodynamik':        'Carbon und Aerodynamik',
    'restauration':              'Restauration',
    /* --- Detailseiten --- */
    'pleuellager-service':       'Pleuellager-Service',
    'crank-hub-fix-s55':         'Crank Hub Fix für S55',
    'vanos-service':             'Vanos-Service',
    'hinterachsverstaerkung-e46':'E46 Hinterachsverstärkung',
    'dkg-service':               'DKG-Service',
    'automatikgetriebe-service': 'Automatikgetriebe-Service',
    'csl-umbauten-e46':          'CSL-Umbauten am E46',
    'aeroteile-g8x-g87':         'Carbon- und Aeroteile G8X/G87',
    'carbondach-service':        'Carbondach und Carbonhaube',
    'heckfluegel-montage':       'Heckflügel und Heckspoiler',
    'hr-fahrwerk-bmw':           'H&R Fahrwerk',
    'kw-fahrwerk-bmw':           'KW Fahrwerk',
    'achsvermessung-eintragung': 'Achsvermessung und Eintragung',
    'bremsen-bmw':               'Bremsen für BMW',
    'steuerkette-n55-s55':       'Steuerkette N55 und S55',
    'drosselklappensteller-s65': 'Drosselklappensteller S65',
    'smg-umbau-handschaltung-e46':'SMG auf Handschaltung E46',
    'softwaretuning':            'Softwaretuning',
    'abgasanlagen':              'Abgasanlagen',
    /* --- Marken und Leistungsseiten je Marke (12.10.2026) --- */
    'marken':                    'Allgemeine Anfrage',
    'bmw-leistungssteigerung':   'Leistungssteigerung BMW',
    'alpina-leistungssteigerung':'Leistungssteigerung Alpina',
    'mini-leistungssteigerung':  'Leistungssteigerung MINI',
    'audi-tuning':               'Audi',
    'audi-leistungssteigerung':  'Leistungssteigerung Audi',
    'audi-rs6-c8-leistungssteigerung': 'Audi RS6 C8 – 1.001 PS',
    'audi-r8-v10-leistungssteigerung': 'Audi R8 V10',
    'apr-tuning':                'APR-Tuning',
    'vw-leistungssteigerung':    'Leistungssteigerung VW',
    'seat-leistungssteigerung':  'Leistungssteigerung Seat',
    'cupra-leistungssteigerung': 'Leistungssteigerung Cupra',
    'skoda-leistungssteigerung': 'Leistungssteigerung Skoda',
    'mercedes-amg-tuning':       'Mercedes-AMG',
    'mercedes-amg-leistungssteigerung': 'Leistungssteigerung Mercedes-AMG',
    'porsche-tuning':            'Porsche',
    'lamborghini-tuning':        'Lamborghini',
    'ferrari-tuning':            'Ferrari',
    'alpina-tuning':             'Alpina',
    'porsche-leistungssteigerung': 'Leistungssteigerung Porsche',
    'toyota-leistungssteigerung':  'Leistungssteigerung Toyota',
    'hyundai-leistungssteigerung': 'Leistungssteigerung Hyundai und Kia',
    'bentley-leistungssteigerung': 'Leistungssteigerung Bentley',
    /* --- Altlasten: fruehere Slugs, damit alte Links weiter funktionieren --- */
    'crank-hub-fix':             'Crank Hub Fix für S55',
    'hinterachse-e46':           'E46 Hinterachsverstärkung',
    'einbau-abgasanlage':        'Abgasanlagen',
    'fahrwerk-achsvermessung':   'Fahrwerk und Achsvermessung'
  };

  (function(){
    var themaFeld  = document.getElementById('mxm-thema');
    var quelleFeld = document.getElementById('mxm-quelle');
    var banner     = root.querySelector('.mxm-topic');
    if(quelleFeld) quelleFeld.value = window.location.pathname + window.location.search;

    var slug = '', produkt = '', art = '';
    try{
      var par = new URLSearchParams(window.location.search);
      slug    = par.get('thema')   || '';
      produkt = par.get('produkt') || '';
      art     = par.get('art')     || '';
    }catch(e){}
    if(!slug && !produkt && !art) return;

    /* ?art= kommt aus dem Shop (Produktseite, Warenkorb, Suche) und bestimmt den
       vorausgefuellten Text: einbau | passt | preis | frage | suche | verfuegbar.
       Ohne art bleibt alles wie bisher (Links von den Leistungsseiten). */
    var ARTEN = {
      einbau:     { label:'Einbau-Anfrage',              text:'Einbau in Hirschaid für: ' },
      passt:      { label:'Passt das zu meinem Auto?',   text:'Passt das zu meinem Auto? ' },
      preis:      { label:'Preisanfrage',                text:'Preisanfrage zu: ' },
      frage:      { label:'Frage zum Produkt',           text:'Frage zu: ' },
      suche:      { label:'Teil gesucht',                text:'Ich suche: ' },
      verfuegbar: { label:'Produktanfrage',              text:'Anfrage zu: ' }
    };
    var A = ARTEN[art] || null;

    var label = slug
      ? (THEMEN[slug] || slug.replace(/-/g,' ').replace(/^./,function(c){ return c.toUpperCase(); }))
      : (A ? A.label : 'Produktanfrage');
    if(slug && A && art !== 'verfuegbar') label = A.label + ' · ' + label;

    /* Ausverkaufte Produkte verlinken von den Leistungsseiten hierher statt auf
       die Produktseite, wo nur ein ausgegrauter Kaufen-Knopf wartet. Der
       Produktname kommt als ?produkt= mit, damit Max sofort sieht, worum es
       geht, und der Kunde ihn nicht abtippen muss. */
    if(produkt){
      produkt = produkt.replace(/\s+/g,' ').trim().slice(0,140);
      label   = label + ' · ' + produkt;

      var anliegen = document.getElementById('mxm-anliegen');
      if(anliegen && !anliegen.value){
        if(A && art !== 'verfuegbar'){
          anliegen.value = A.text + produkt + '\n'
                         + (art === 'passt' ? 'Fahrgestellnummer: \n' : '') + '\n';
        } else {
          anliegen.value = 'Anfrage zu: ' + produkt + '\n'
                         + '(laut Shop derzeit ausverkauft)\n\n';
        }
        /* Der Fortschrittsbalken zaehlt ausgefuellte Pflichtfelder. Ohne das
           Ereignis bliebe er stehen, obwohl das Feld schon Inhalt hat. */
        try{ anliegen.dispatchEvent(new Event('input', {bubbles:true})); }catch(e){}
      }
    }

    if(themaFeld) themaFeld.value = label;
    if(banner){ banner.querySelector('.v').textContent = label; banner.hidden = false; }
  })();

  /* ---- Fahrzeugliste: hier erweitern, wenn Baureihen dazukommen ---- */
  var MODELLE = {
    "E36 (1990–2000)":["318i / 320i / 325i","328i","M3 3.0","M3 3.2","Compact","Anderes E36"],
    "E39 / E38 (1995–2004)":["528i / 530i","540i","M5 E39","7er E38","Anderes"],
    "E46 (1998–2006)":["318i / 320i","325i / 328i","330i","330d","M3","M3 CSL","Anderes E46"],
    "E60 / E63 (2003–2010)":["525i / 530i","535d","545i / 550i","M5 E60","M6 E63","Anderes"],
    "E9x (2005–2013)":["320d","325d","330d","335d","325i / 330i","335i","M3 E90 / E92 / E93","Anderes E9x"],
    "F2x / F3x (2011–2019)":["20d","25d","30d","35d","30i","35i","40i","Anderes F2x / F3x"],
    "F8x (2014–2020)":["M2 F87","M2 Competition","M2 CS","M3 F80","M3 Competition","M4 F82 / F83","M4 Competition","M4 CS / GTS"],
    "G2x / G4x (ab 2018)":["M340i / M440i","M240i","30i / 40i","20d / 30d","Anderes G2x / G4x"],
    "G8x (ab 2021)":["M2 G87","M3 G80 / G81","M3 Competition","M4 G82 / G83","M4 Competition","M3 / M4 CS","Anderes G8x"],
    "X-Modelle":["X3M / X4M","X5M / X6M","X5 / X6 Diesel","Anderes X-Modell"],
    "Andere Baureihe":["Bitte im Anliegen beschreiben"]
  };

  var $ = function(id){ return document.getElementById(id); };
  var baureihe=$('mxm-baureihe'), modell=$('mxm-modell'), getriebe=$('mxm-getriebe'),
      marke=$('mxm-marke'), variante=$('mxm-variante'),
      consent=root.querySelector('.mxm-consent--dsgvo'),
      progress=root.querySelector('.mxm-progress');
  if(!baureihe) return;
  var fill=progress.querySelector('.mxm-fill'), counter=progress.querySelector('.mxm-n'),
      total=progress.querySelector('.mxm-total');
  var blkBaureihe=baureihe.closest('.mxm-block'), blkModell=modell.closest('.mxm-block'),
      blkVariante=$('mxm-variante-block'), lblBaureihe=$('mxm-baureihe-label'),
      lblVariante=blkVariante ? blkVariante.querySelector('.mxm-lbl') : null,
      motor=$('mxm-motor');
  var art='bmw'; /* bmw | marke | andere */

  function fillBaureiheBmw(){
    baureihe.setAttribute('data-bmw','1');
    baureihe.innerHTML='';
    baureihe.appendChild(new Option('Bitte auswählen',''));
    Object.keys(MODELLE).forEach(function(k){ baureihe.appendChild(new Option(k,k)); });
  }
  fillBaureiheBmw();

  function fillModellBmw(){
    modell.innerHTML='';
    var list=MODELLE[baureihe.value];
    if(!list){ modell.disabled=true; modell.appendChild(new Option('Zuerst Baureihe wählen','')); return; }
    modell.disabled=false;
    modell.appendChild(new Option('Bitte auswählen',''));
    list.forEach(function(m){ modell.appendChild(new Option(m,m)); });
  }

  /* Marke umschalten: BMW mit Baureihe und Modell, andere Marken mit Modell aus der Markenliste */
  function setMarke(){
    var opt=marke && marke.options[marke.selectedIndex];
    var k=opt ? (opt.getAttribute('data-k')||'') : '';
    art = (k==='' || k==='bmw') ? 'bmw' : (k==='andere' ? 'andere' : 'marke');
    if(art==='bmw'){
      lblBaureihe.textContent='Baureihe';
      if(baureihe.getAttribute('data-bmw')!=='1') fillBaureiheBmw();
      blkBaureihe.hidden=false; baureihe.required=true;
      blkModell.hidden=false; modell.required=true; fillModellBmw();
      if(blkVariante){ blkVariante.hidden=true; variante.required=false; }
    } else if(art==='marke'){
      lblBaureihe.textContent='Modell';
      baureihe.removeAttribute('data-bmw');
      baureihe.innerHTML='';
      baureihe.appendChild(new Option('Bitte auswählen',''));
      (opt.getAttribute('data-modelle')||'').split(',').forEach(function(m){
        m=m.split('=')[0].trim(); if(m) baureihe.appendChild(new Option(m,m));
      });
      baureihe.appendChild(new Option('Anderes Modell','Anderes Modell'));
      blkBaureihe.hidden=false; baureihe.required=true;
      blkModell.hidden=true; modell.required=false; modell.disabled=true;
      if(blkVariante){ blkVariante.hidden=false; variante.required=false;
        if(lblVariante) lblVariante.innerHTML='Modell genau <span class="opt">optional</span>'; variante.placeholder='z. B. RS6 Avant 4.0 TFSI'; }
    } else {
      blkBaureihe.hidden=true; baureihe.required=false;
      blkModell.hidden=true; modell.required=false; modell.disabled=true;
      if(blkVariante){ blkVariante.hidden=false; variante.required=true;
        if(lblVariante) lblVariante.textContent='Marke und Modell'; variante.placeholder='z. B. Nissan GT-R R35'; }
    }
    if(motor) motor.placeholder = art==='bmw' ? 'S58, N55, S65 …' : 'z. B. EA888, M177, 2.5 TFSI';
    var smg=root.querySelector('[aria-labelledby="mxm-getriebe-label"] .mxm-chip[data-val="SMG"]');
    if(smg){ smg.hidden = art!=='bmw'; if(smg.hidden && getriebe.value==='SMG'){ smg.setAttribute('aria-pressed','false'); getriebe.value=''; } }
  }
  if(marke) marke.addEventListener('change', function(){ setMarke(); update(); });
  setMarke();

  baureihe.addEventListener('change', function(){
    if(art==='bmw') fillModellBmw();
    update();
  });

  /* Vorbelegung: ?marke=&modell=, sonst Marke aus ?thema=, sonst Fahrzeugwahl aus dem Browser */
  (function(){
    if(!marke) return;
    var par=null; try{ par=new URLSearchParams(window.location.search); }catch(e){}
    var mk=par ? (par.get('marke')||'').toLowerCase() : '', md=par ? (par.get('modell')||'') : '', th=par ? (par.get('thema')||'') : '';
    var MOD_THEMA={'audi-rs6-c8-leistungssteigerung':'RS6 C8','audi-r8-v10-leistungssteigerung':'R8 V10'};
    var keys=Array.prototype.map.call(marke.options, function(o){ return o.getAttribute('data-k')||''; }).filter(Boolean)
      .sort(function(a,b){ return b.length-a.length; });
    if(!mk && th){
      for(var i=0;i<keys.length;i++){ if(keys[i]!=='andere' && th.indexOf(keys[i]+'-')===0){ mk=keys[i]; break; } }
      if(!md && MOD_THEMA[th]) md=MOD_THEMA[th];
    }
    var bmwBr='';
    if(!mk){
      try{
        var fz=JSON.parse(window.localStorage.getItem('mx_fz')||'null');
        if(fz && fz.k){ mk=fz.k; md=fz.m||''; }
        var bt=window.localStorage.getItem('mx_bmw');
        var BR={'fz-g8x':'G8x (ab 2021)','fz-f8x':'F8x (2014–2020)','fz-e9x-m3':'E9x (2005–2013)','fz-e46-m3':'E46 (1998–2006)','fz-e36-e46':'E36 (1990–2000)'};
        if(!mk && bt){ mk='bmw'; bmwBr=BR[bt]||''; }
      }catch(e){}
    }
    if(!mk) return;
    var found=false;
    Array.prototype.forEach.call(marke.options, function(o,i){ if(o.getAttribute('data-k')===mk){ marke.selectedIndex=i; found=true; } });
    if(!found) return;
    setMarke();
    if(art==='bmw' && bmwBr){ baureihe.value=bmwBr; fillModellBmw(); }
    if(art==='marke' && md){
      var hit=false;
      Array.prototype.forEach.call(baureihe.options, function(o){ if(o.value.toLowerCase()===md.toLowerCase()){ baureihe.value=o.value; hit=true; } });
      if(!hit){ baureihe.value='Anderes Modell'; if(variante && !variante.value) variante.value=md.slice(0,80); }
    }
  })();

  var chips=Array.prototype.slice.call(root.querySelectorAll('[aria-labelledby="mxm-getriebe-label"] .mxm-chip'));
  chips.forEach(function(c){
    c.addEventListener('click', function(){
      var on=c.getAttribute('aria-pressed')==='true';
      chips.forEach(function(x){ x.setAttribute('aria-pressed','false'); });
      c.setAttribute('aria-pressed', String(!on));
      getriebe.value = on ? '' : c.dataset.val;
      update();
    });
  });

  /* Mehrfachauswahl „Worum geht es?“ – landet als Liste im Feld Leistung */
  var leistung=$('mxm-leistung');
  var multi=Array.prototype.slice.call(root.querySelectorAll('[data-mxm-multi] .mxm-chip'));
  function syncMulti(){
    if(!leistung) return;
    leistung.value=multi.filter(function(x){ return x.getAttribute('aria-pressed')==='true'; })
                        .map(function(x){ return x.dataset.val; }).join(', ');
  }
  multi.forEach(function(c){
    c.addEventListener('click', function(){
      c.setAttribute('aria-pressed', String(c.getAttribute('aria-pressed')!=='true'));
      syncMulti();
    });
  });
  (function(){
    var th=''; try{ th=(new URLSearchParams(window.location.search)).get('thema')||''; }catch(e){}
    if(!th) return;
    var MAP=[[/leistungssteigerung|softwaretuning|apr-tuning/,'Leistungssteigerung'],[/abgasanlage/,'Abgasanlage'],
             [/fahrwerk|kw-|hr-|achsvermessung|hinterachse/,'Fahrwerk'],[/bremse/,'Bremsen'],
             [/service|pleuellager|vanos|dkg|steuerkette|getriebe|crank-hub|drosselklappe|smg/,'Service / Reparatur']];
    for(var i=0;i<MAP.length;i++){
      if(MAP[i][0].test(th)){
        multi.forEach(function(x){ if(x.dataset.val===MAP[i][1]) x.setAttribute('aria-pressed','true'); });
        break;
      }
    }
    syncMulti();
  })();

  /* Pflichtangaben je nach Marke: BMW mit Baureihe und Modell, andere Marken mit Modell, „Andere Marke“ mit Freitext */
  function req(){
    var fz = art==='bmw' ? ['mxm-baureihe','mxm-modell'] : (art==='marke' ? ['mxm-baureihe'] : ['mxm-variante']);
    return {
      all:['mxm-vorname','mxm-nachname','mxm-mail','mxm-marke'].concat(fz,['mxm-baujahr','mxm-getriebe','mxm-anliegen']),
      steps:{1:['mxm-vorname','mxm-nachname','mxm-mail'], 2:['mxm-marke'].concat(fz,['mxm-baujahr','mxm-getriebe']), 3:['mxm-anliegen']}
    };
  }

  function filled(id){
    var el=$(id); if(!el || !el.value.trim()) return false;
    if(id==='mxm-mail') return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.value.trim());
    return true;
  }

  function update(){
    var R=req(), REQ=R.all, STEPS=R.steps;
    var n=REQ.filter(filled).length;
    counter.textContent=n;
    if(total) total.textContent=REQ.length;
    fill.style.width=(n/REQ.length*100)+'%';
    progress.classList.toggle('is-complete', n===REQ.length);
    var activeSet=false;
    Object.keys(STEPS).forEach(function(s){
      var el=root.querySelector('.mxm-step[data-step="'+s+'"]');
      if(!el) return;
      var allDone=STEPS[s].every(filled);
      el.classList.toggle('is-done', allDone);
      el.classList.toggle('is-active', !allDone && !activeSet);
      if(!allDone) activeSet=true;
    });
  }
  form.addEventListener('input', update);
  form.addEventListener('change', update);

  /* ---- Klaviyo: Anmeldung aus dem Browser, nur mit oeffentlichem Key ---- */
  function klaviyoSubscribe(){
    var key  = root.dataset.klaviyoKey;
    var list = root.dataset.klaviyoList;
    var mail = $('mxm-mail').value.trim();
    if(!key || !list || !mail){
      console.warn('[MX] Klaviyo uebersprungen – Key, Listen-ID oder E-Mail fehlt.');
      return Promise.resolve();
    }

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: mail,
                first_name: $('mxm-vorname').value.trim(),
                last_name:  $('mxm-nachname').value.trim(),
                properties: {
                  Marke:     marke ? marke.value : '',
                  Baureihe:  baureihe.value,
                  Modell:    modell.value,
                  Baujahr:   $('mxm-baujahr').value.trim(),
                  Motorcode: $('mxm-motor').value.trim(),
                  Quelle:    'Anfrageformular',
                  /* Nachweis der Einwilligung – bei Single Opt-in liegt die
                     Beweislast beim Shop, deshalb wird sie hier mitgeschrieben. */
                  Einwilligung_Zeitpunkt: new Date().toISOString(),
                  Einwilligung_Quelle:    window.location.href,
                  Einwilligung_Art:       'Single Opt-in, aktiv gesetzter Haken im Anfrageformular'
                },
                /* Die Einwilligung gehoert INS Profil, nicht eine Ebene
                   darueber. Lag sie aussen, antwortete Klaviyo mit
                   HTTP 400 "'subscriptions' is not a valid field for the
                   resource 'subscription'". Bitte nicht verschieben. */
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    /* Gibt ein Promise zurueck. Wichtig: Der Browser schickt wegen des
       revision-Headers zuerst eine Vorabanfrage (OPTIONS) und erst danach
       den POST. Wuerde das Formular sofort absenden, bricht der Seitenwechsel
       beides ab und in Klaviyo kommt nichts an. Deshalb wartet das Absenden
       unten auf dieses Promise. Bewusst OHNE keepalive: Chrome bricht
       keepalive-Anfragen mit Vorabanfrage ab ("Failed to fetch"). */
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(key), {
      method:'POST',
      headers:{'Content-Type':'application/json','revision':'2026-07-15'},
      body: JSON.stringify(body),
      mode: 'cors'
    }).then(function(res){
      if(res.ok || res.status===202){
        console.log('[MX] Klaviyo: Anmeldung uebermittelt (HTTP '+res.status+')');
        return;
      }
      return res.text().then(function(t){
        console.error('[MX] Klaviyo hat abgelehnt – HTTP '+res.status+': '+t);
      });
    }).catch(function(err){
      console.error('[MX] Klaviyo nicht erreichbar:', err);
    });
  }

  var abgeschickt = false;

  form.addEventListener('submit', function(e){
    if($('mxm-website').value){ e.preventDefault(); return; }

    var ok=true;
    req().all.forEach(function(id){
      var el=$(id), wrap=el.closest('.mxm-block');
      var bad=!filled(id);
      if(wrap) wrap.classList.toggle('mxm-invalid', bad);
      if(bad) ok=false;
    });
    var d=$('mxm-dsgvo');
    consent.classList.toggle('mxm-invalid', !d.checked);
    if(!d.checked) ok=false;

    if(!ok){
      e.preventDefault();
      var first=root.querySelector('.mxm-invalid');
      if(first) first.scrollIntoView({behavior:'smooth',block:'center'});
      return;
    }

    /* Ohne Newsletter-Haken geht das Formular direkt raus. */
    if(!($('mxm-news') && $('mxm-news').checked)) return;

    /* Mit Haken: Seitenwechsel anhalten, bis Klaviyo geantwortet hat.
       Spaetestens nach 2,5 Sekunden wird trotzdem abgeschickt – die Anfrage
       an Max ist wichtiger als die Newsletter-Anmeldung. */
    if(abgeschickt) return;
    e.preventDefault();

    var btn = form.querySelector('.mxm-submit span');
    var btnText = btn ? btn.textContent : '';
    if(btn) btn.textContent = 'Wird gesendet …';

    var weiter = function(){
      if(abgeschickt) return;
      abgeschickt = true;
      clearTimeout(notbremse);
      if(btn) btn.textContent = btnText;
      form.submit();          /* loest diesen Handler bewusst nicht erneut aus */
    };
    var notbremse = setTimeout(function(){
      console.warn('[MX] Klaviyo hat nicht rechtzeitig geantwortet – Anfrage geht trotzdem raus.');
      weiter();
    }, 2500);

    klaviyoSubscribe().then(weiter, weiter);
  });

  update();
})();

/* ENDE – diese Zeile muss nach dem Einfuegen sichtbar sein, sonst ist die Datei abgeschnitten */
